<nz-card class="round-border p-4" [nzLoading]="!loaded">
    <a [routerLink]="['/about']">
        <nz-statistic [nzValue]="count | number" [nzTitle]="'about_common_name' | translate"></nz-statistic>
    </a>
</nz-card>